/**
 * Default sort for event registration / sign-up lists: newest registrations first.
 * Call sites use different sort keys for the same registration_date field.
 */
export function createEventRegistrationDefaultSort(key) {
  return { key, direction: "desc" };
}
